import type {ReactNode} from 'react'
import {bodyWrapper} from './roster-body.module.scss'

type Props = {
  children: ReactNode
}

export default function RosterBody(props: Props) {
  const {children} = props
  return <div className={bodyWrapper}>{children}</div>
}
